import React from "react";
import {Link} from 'react-router-dom';

import LightSpeed from 'react-reveal/LightSpeed';
import Pulse from 'react-reveal/Pulse';

import EarlyAccessForm from '../reuse/form/early_access';


export default class HeroSection extends React.Component {

  render (){
    const hero = {
      image: {
        path: '/static/images/hero.svg',
        alt: 'Passive compound hero images',
      },
    }

    return (
      <section id="hero" className=" my-5">
        <HeroTitleSubFeaturesImageComponent hero={hero} />
      </section>
    )
  }
}

function HeroTitleSubFeaturesImageComponent(props){
  const hero = props.hero;
  const is_mobile = window.innerWidth < 1200;
  return (
    <div className="row my-5">

      {(is_mobile)? (
        <div className={" col-12  p-0 img img-fluid text-center align-self-center " + ((is_mobile)? " mt-5 ": " ")}>
          <img className="hero" src={hero.image.path} alt={hero.image.alt} />
        </div> 
      ): ''}

      <div className=" col-md-5 align-self-center m-0 p-0 ">
        <div className="mx-3 ">

        <h1 className="text-left mt-5 p-2">
          <span className="text-primary">Dividend planning </span>
          {/* Financial freedom  */}
          <span className="text-black-2">at your fingertips</span>
        </h1>

        <div className="p-2 my-3">
          <p className="text-left my-3 ">
            Receiving <span className="text-primary ">steady passive dividend income</span> is one of the best ways to get to financial freedom. 
          </p>
          <p className="text-left my-3 ">
            <span className="text-primary strong">PassiveCompound </span>
            helps you explore the different options you may have to hit your goals!
          </p>
          <p className="text-left pb-3"></p>
        </div>

        <div className={((is_mobile)? " my-1 ": " my-5 ")}>
          <div className={"container-fluid " + ((is_mobile)? " py-1 ": " py-5 ")}>
            <LightSpeed left>
              <EarlyAccessForm full_width={true} />
              
              <div className="my-3 texxt-center">
                <Link to={"/survey"} className="">Fill out a 1 minute survey</Link>
                <p className="text-muted small">Increases your chances on getting invited early</p>
              </div>

            </LightSpeed>
          </div>
        </div>

        </div>
      </div> 

      <div className=" col-md-7 d-none d-md-block p-0 text-center align-self-center">
        <Pulse>
          <img className="hero" src={hero.image.path} alt={hero.image.alt} />
        </Pulse>
      </div> 

    </div>
  )
}
